import { FC } from 'react';

import { IconProps } from '../types';

const PreservativeFreeIcon: FC<IconProps> = ({ size, ...props }) => (
  <svg
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    {...props}
    aria-hidden="true"
  >
    <path
      d="M14.695 27.5064H14.6565C13.9768 27.5064 13.4297 26.9549 13.4297 26.2796C13.4297 25.6042 13.9811 25.0527 14.6565 25.0527H14.695C15.3747 25.0527 15.9218 25.6042 15.9218 26.2796C15.9218 26.9549 15.3704 27.5064 14.695 27.5064Z"
      fill="#030303"
      stroke="#030303"
    />
    <path
      d="M17.4305 20.3848H17.4113C17.0714 20.3848 16.7979 20.1091 16.7979 19.7714C16.7979 19.4337 17.0736 19.158 17.4113 19.158H17.4305C17.7703 19.158 18.0439 19.4337 18.0439 19.7714C18.0439 20.1091 17.7682 20.3848 17.4305 20.3848Z"
      fill="#030303"
      stroke="#030303"
    />
    <path
      d="M20.7992 29.648H20.7799C20.4401 29.648 20.1665 29.3723 20.1665 29.0346C20.1665 28.6969 20.4422 28.4211 20.7799 28.4211H20.7992C21.139 28.4211 21.4126 28.6969 21.4126 29.0346C21.4126 29.3723 21.1368 29.648 20.7992 29.648Z"
      fill="#030303"
      stroke="#030303"
    />
    <path
      d="M33.8602 17.7216C33.8602 13.9877 30.823 10.9484 27.087 10.9484C25.6913 10.9484 24.3918 11.3738 23.3125 12.1005V7.8942H24.441C25.2382 7.8942 25.8837 7.24659 25.8837 6.45365V5.44269C25.8837 4.64761 25.2361 4 24.441 4H12.2903C11.4952 4 10.8519 4.64761 10.8519 5.44056V6.45578C10.8519 7.24873 11.4974 7.8942 12.2903 7.8942H13.421V16.093C9.99483 17.914 7.7998 21.5389 7.7998 25.4331C7.7998 29.3273 9.91148 32.8581 13.312 34.7133C14.853 35.5554 16.6013 36 18.3667 36C20.1322 36 21.8826 35.5554 23.4215 34.7133C26.822 32.856 28.9337 29.3016 28.9337 25.4331C28.9337 25.0355 28.908 24.6444 28.8631 24.2554C31.7378 23.4731 33.858 20.84 33.858 17.7216H33.8602ZM12.2903 6.66738C12.1728 6.66738 12.0787 6.57334 12.0787 6.45578V5.44056C12.0787 5.323 12.1728 5.22896 12.2903 5.22896H24.441C24.5607 5.22896 24.6569 5.323 24.6569 5.44269V6.45365C24.6569 6.5712 24.5607 6.66738 24.441 6.66738H22.6991C22.3614 6.66738 22.0857 6.94309 22.0857 7.28079V10.1833C20.5789 10.1512 19.6983 10.5466 18.9139 10.8993C18.0846 11.2733 17.3686 11.596 15.8981 11.4913C15.4322 11.4571 15.0197 11.3866 14.6457 11.2819V7.28293C14.6457 6.94309 14.3699 6.66952 14.0322 6.66952H12.2903V6.66738ZM27.709 25.4331C27.709 28.8528 25.8409 31.9968 22.8359 33.6361C21.4744 34.3799 19.9312 34.771 18.3689 34.771C16.8065 34.771 15.2633 34.3778 13.9019 33.6361C10.8968 31.9968 9.02877 28.8507 9.02877 25.4331C9.02877 22.0155 11.0998 18.5723 14.3015 17.0206C14.5131 16.918 14.6478 16.7042 14.6478 16.4691V12.5472C15.009 12.6284 15.3937 12.6882 15.8126 12.7181C16.0264 12.7331 16.2294 12.7417 16.4218 12.7417C17.8238 12.7417 18.666 12.3612 19.4204 12.0214C20.1813 11.6773 20.8482 11.378 22.0878 11.4122V13.1606C20.9892 14.366 20.316 15.9669 20.316 17.7216C20.316 21.4555 23.3531 24.4948 27.0891 24.4948C27.2815 24.4948 27.4696 24.4841 27.6577 24.4691C27.6919 24.7876 27.7111 25.1103 27.7111 25.4352L27.709 25.4331ZM27.0891 23.2658C24.0306 23.2658 21.5428 20.778 21.5428 17.7216C21.5428 14.6652 24.0306 12.1774 27.0891 12.1774C30.1477 12.1774 32.6334 14.6652 32.6334 17.7216C32.6334 20.778 30.1455 23.2658 27.0891 23.2658Z"
      fill="#030303"
      stroke="#030303"
    />
    <path
      d="M25.1632 20.274C25.0072 20.274 24.849 20.2141 24.7293 20.0944C24.49 19.855 24.49 19.466 24.7293 19.2267L28.5765 15.3795C28.8159 15.1401 29.2049 15.1401 29.4443 15.3795C29.6837 15.6189 29.6837 16.0079 29.4443 16.2472L25.5971 20.0944C25.4774 20.2141 25.3192 20.274 25.1632 20.274Z"
      fill="#030303"
      stroke="#030303"
      strokeWidth="0.75"
    />
    <path
      d="M29.0129 20.274C28.8568 20.274 28.6987 20.2141 28.579 20.0944L24.7318 16.2472C24.4924 16.0079 24.4924 15.6189 24.7318 15.3795C24.9712 15.1401 25.3602 15.1401 25.5996 15.3795L29.4467 19.2267C29.6861 19.466 29.6861 19.855 29.4467 20.0944C29.3271 20.2141 29.1689 20.274 29.0129 20.274Z"
      fill="#030303"
      stroke="#030303"
      strokeWidth="0.75"
    />
  </svg>
);

export default PreservativeFreeIcon;
